export enum UserSettingsPropertyType {
    Email = 0,
    Language = 1,
    Password = 2,
    TwoFactor = 3,
    TwoFactorRemoval = 4
}
